import { Link } from 'react-router-dom';
import { siteConfig } from '@/config/site';
import { mangaCategories } from '@/mocks/manga';

function Footer() {
  return (
    <footer className="mt-16 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2" title={`${siteConfig.name} 首页`}>
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-book-2-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">{siteConfig.name}</span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              {siteConfig.tagline}，海量在线漫画资源，按题材、类型、标签轻松找到你喜欢的漫画。
            </p>
            <div className="mt-4 flex items-center gap-3">
              <a href="https://weibo.com" rel="nofollow noopener" aria-label="微博" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50">
                <i className="ri-weibo-fill"></i>
              </a>
              <a href="https://weixin.qq.com" rel="nofollow noopener" aria-label="微信" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50">
                <i className="ri-wechat-fill"></i>
              </a>
              <a href="https://www.douban.com" rel="nofollow noopener" aria-label="豆瓣" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50">
                <i className="ri-quill-pen-fill"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-950">题材分类</h4>
            <ul className="mt-4 space-y-2">
              {mangaCategories.slice(0, 4).map((c) => (
                <li key={c.slug}>
                  <Link to={`/category/${c.slug}`} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-950">快速导航</h4>
            <ul className="mt-4 space-y-2">
              <li><Link to="/category" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">全部漫画</Link></li>
              <li><Link to="/category?status=finished" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">完结漫画</Link></li>
              <li><Link to="/category?status=serializing" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">连载中漫画</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-950">联系我们</h4>
            <ul className="mt-4 space-y-2 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500"></i>
                {siteConfig.email}
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-primary-500"></i>
                {siteConfig.phone}
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-primary-500"></i>
                {siteConfig.address}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-600">
            © {new Date().getFullYear()} {siteConfig.name} 版权所有
          </p>
          <div className="flex flex-wrap items-center gap-4">
            <a href="/about" className="text-xs text-foreground-600 transition-colors hover:text-primary-600">隐私政策</a>
            <a href="/about" className="text-xs text-foreground-600 transition-colors hover:text-primary-600">版权声明</a>
            <a href="/about" className="text-xs text-foreground-600 transition-colors hover:text-primary-600">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;